import {
    Col,
    Form,
    Row
} from "react-bootstrap";
import { Controller } from "react-hook-form";
import DatePicker from "react-datepicker";
import { addMonths } from 'date-fns';

export const DatePickerSection = ({ control, showDatePicker }) => (
    <div className="bg-light p-4 rounded-4 border border-light mb-4">
        <Row className="g-3">
            <Col md={12}>
                <h5 className="fw-bold text-secondary mb-3">Fecha de activación</h5>
            </Col>
            <Col md={12}>
                <Controller
                    control={control}
                    name="showDatePicker"
                    render={({ field }) => (
                        <div className="d-flex gap-3 align-items-center">
                            <Form.Check
                                {...field}
                                type="radio"
                                id="fecha-fija"
                                label={<span className="fw-bold text-secondary">Fecha fija</span>}
                                value="true"
                                checked={field.value === "true"}
                                onChange={(e) => field.onChange(e.target.value)}
                                className="custom-radio"
                            />
                            <Form.Check
                                {...field}
                                type="radio"
                                id="cuanto-antes"
                                label={<span className="fw-bold text-secondary">Lo antes posible</span>}
                                value="false"
                                checked={field.value === "false"}
                                onChange={(e) => field.onChange(e.target.value)}
                                className="custom-radio"
                            />
                        </div>
                    )}
                />
            </Col>
            {showDatePicker === "true" && (
                <Col md={12}>
                    <label className="text-muted small fw-bold text-uppercase mb-2">Fecha Estimada</label>
                    <Controller
                        control={control}
                        name="fecha_estimada_inicio_ctto"
                        render={({ field: { value, onChange, onBlur } }) => (
                            <div className="datepicker-modern-wrapper">
                                <DatePicker
                                    locale="es"
                                    dateFormat="yyyy-MM-dd"
                                    showIcon
                                    onChange={onChange}
                                    onBlur={onBlur}
                                    selected={value}
                                    minDate={new Date()}
                                    maxDate={addMonths(new Date(), 2)}
                                    className="form-control bg-white rounded-3 shadow-sm border-light"
                                    wrapperClassName="w-100"
                                    placeholderText="Seleccione una fecha"
                                />
                            </div>
                        )}
                    />
                </Col>
            )}
        </Row>
    </div>
);